export default __webpack_public_path__ + "static/media/logo.1734d3af.png";